import React from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";

import Button from "../Button";
import DateField from "../DateField";
import TermsOfServiceLink from "../TermsOfServiceLink";
import PrivacyPolicyLink from "../PrivacyPolicyLink";

export default function AgeGateBox({ locked, onChange, onBlur, error }) {
  const router = useRouter();

  return (
    <div className="flex flex-col space-y-md items-center text-center">
      <div className="space-y-sm">
        <h1 className="gn-headline-md">
          {locked ? "Sorry, buddy!" : "Are you a grown up?"}
        </h1>
        <p className="gn-text" data-testid="age-gate-box-description">
          {locked
            ? "You need a grown up to help you."
            : "If not, get a grown up to help you register!"}
        </p>
      </div>
      {locked === false ? (
        <>
          <div className="text-left w-1/2">
            <DateField
              label="Date of Birth"
              required
              errorMessage={error}
              onChange={(date) => {
                const isValidDate = date?.year && date?.month && date?.day;
                if (isValidDate) {
                  // interval to duration.
                  const years =
                    new Date(new Date() - date.toDate()).getFullYear() - 1970;
                  onChange(years);
                } else {
                  onChange(undefined);
                }
              }}
              onBlur={onBlur}
            />
          </div>
          <p className="gn-text-sm" data-testid="age-gate-box-description">
            We won&apos;t store this information. Learn more by reading our{" "}
            <TermsOfServiceLink className="cursor-pointer underline" />
            &nbsp;and&nbsp;
            <PrivacyPolicyLink className="cursor-pointer underline" />
          </p>
          <div className="w-full flex space-x-sm xs:space-x-md">
            <Button
              mode="dark-outline"
              label="Cancel"
              size="md"
              onClick={() => router.back()}
              className="w-full"
            />
            <Button
              mode="dark"
              label="Continue"
              size="md"
              type="submit"
              className="w-full"
            />
          </div>
        </>
      ) : null}

      <div
        className={`flex flex-col space-y-md w-full ${!locked ? "hidden" : ""}`}
      >
        <div className="self-center mr-4">
          <img
            className="w-[150px] h-[180px] object-contain"
            width={150}
            height={180}
            src="https://cdn.gonoodle.com/Universe-Component-Library/general/McPufferson-L1-sad.svg"
            alt=""
          />
        </div>
        <Button
          mode="dark"
          label="Watch GoNoodle Videos"
          size="md"
          onClick={() => router.back()}
        />
      </div>
    </div>
  );
}

AgeGateBox.propTypes = {
  locked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.string,
};

AgeGateBox.defaultProps = {
  locked: false,
  onChange: () => {},
  onBlur: () => {},
  error: undefined,
};
